import React from 'react';
import {Grid, Typography, Input, Checkbox,Button, Radio, FormControl, FormLabel, RadioGroup, Select,MenuItem,InputLabel } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Slider from '@material-ui/core/Slider';
import FormControlLabel from '@material-ui/core/FormControlLabel';

class InputData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onChange=(name,val)=>{
    this.setState({
      [name]:val
    })
  }

  submitData=()=>{
    this.props.onSubmit(this.state);

  }


  render() {
    return (
      <div>
        <Box border="3px solid gray">
          <Grid container direction="column" >
            <Row label="Age" input=<AgeSlider onChange = {this.onChange}></AgeSlider> desc="Years"></Row>
            <Row label="Temperature" input=<TempInput onChange = {this.onChange}></TempInput> desc= "°C"></ Row>
            <Row label="BMI" input=<BMIInput onChange = {this.onChange}></BMIInput> desc=''></Row>
            <Row
              label="Sex"
              input=<SexCheckbox onChange = {this.onChange} name = "sex"></SexCheckbox>
              >
            </Row>

            <Row
              label="Chronic kidney disease"
              input=<UniformCheckbox onChange = {this.onChange} name = "ckd"></UniformCheckbox>
              >
            </Row>

            <Row
              label="Shortness of Breath"
              input=<UniformCheckbox onChange = {this.onChange} name = "sob"></UniformCheckbox>
              >
            </Row>

            <Row
              label="Cancer"
              input=<UniformCheckbox onChange = {this.onChange} name = "cancer"></UniformCheckbox>
              >
            </Row>

            <Row
              label="Diabetes"
              input=<UniformCheckbox onChange = {this.onChange} name = "dm"></UniformCheckbox>
              >
            </Row>


          </Grid>
        </Box>
        <Grid container alignItems="flex-start" justify="flex-end" direction="row">
          <Button variant='contained' color='primary' onClick={this.submitData}>Submit</Button>
        </Grid>
      </div>

    );
  }
}

export default InputData;

class Row extends React.Component {
  render() {
    return(
      <Grid container
        direction="row"
        spacing={1}
        justify="flex-start"
        alignItems="center"
        >
          <Grid item xs={3}>
            <Typography>
              <Box fontWeight = "fontWeightBold" fontSize={15} ml={1}>
                {this.props.label}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            {this.props.input}
          </Grid>
          <Grid item xs={1}>
            <Typography>
              <Box fontSize={20}>
                {this.props.desc}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={1}/>
      </Grid>
    );
  }
}

class AgeSlider extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,e.target.value);
    if(isNaN(e.target.value)||parseFloat(e.target.value)<0||parseFloat(e.target.value)>97){
      this.setState({error:true})
    }
    else{
      this.setState({error:false})
    }
  }
  render(){
    return (
      <Input
        onChange = {this.onChange('age')}
        fullWidth={true}
        placeholder="Range : 0 - 97"
        error={this.state.error}

      />
    );
  }
}

class UniformCheckbox extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,(e.target.value));
  }
  render(){
    return (
      <FormControl  component="fieldset">
          <RadioGroup row aria-label="gender" name="gender1" onChange={this.onChange(this.props.name)}>
            <FormControlLabel value="0" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >No</Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Yes</Box>
                </Typography>
              </div>
            />
          </RadioGroup>
      </FormControl>

    );
  }
}

class SexCheckbox extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,(e.target.value));
  }
  render(){
    return (
      <FormControl  component="fieldset">
          <RadioGroup row aria-label="gender" name="gender1" onChange={this.onChange(this.props.name)}>
            <FormControlLabel value="0" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Male</Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Female</Box>
                </Typography>
              </div>
            />
          </RadioGroup>
      </FormControl>

    );
  }
}





class TempInput extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,e.target.value);
    if(isNaN(e.target.value)||parseFloat(e.target.value)<36.2||parseFloat(e.target.value)>40){
      this.setState({error:true})
    }
    else{
      this.setState({error:false})
    }
  }
  render(){
    return (
        <Input
          onChange = {this.onChange('temperature')}
          fullWidth={true}
          placeholder="Range : 36.2 - 40"
          error={this.state.error}
        />
    );
  }
}

class BMIInput extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,e.target.value);
    if(isNaN(e.target.value)||parseFloat(e.target.value)<5.19||parseFloat(e.target.value)>66.79){
      this.setState({error:true})
    }
    else{
      this.setState({error:false})
    }

  }
  render(){
    return (
        <Input
          onChange = {this.onChange('bmi')}
          fullWidth={true}
          placeholder="Range : 5.19 - 66.79"
          error={this.state.error}
        />
    );
  }
}

class LympInput extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,e.target.value);
    if(isNaN(e.target.value)||parseFloat(e.target.value)<1.2||parseFloat(e.target.value)>84.1){
      this.setState({error:true})
    }
    else{
      this.setState({error:false})
    }
  }
  render(){
    return (
        <Input
          onChange = {this.onChange('lymphocyte')}
          fullWidth={true}
          placeholder="Range : 1.2 - 84.1"
          error={this.state.error}

        />
    );
  }
}

class WbcInput extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    if(isNaN(e.target.value)||parseFloat(e.target.value)<660||parseFloat(e.target.value)>55000){
      this.setState({error:true})
    }
    else{
      this.setState({error:false})
    }
    this.props.onChange(name,e.target.value);
  }
  render(){
    return (
        <Input
          onChange = {this.onChange('wbc')}
          fullWidth={true}
          placeholder="Range : 660 - 55000"
          error={this.state.error}
        />
    );
  }
}

class PltInput extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    if(isNaN(e.target.value)||parseFloat(e.target.value)<5300||parseFloat(e.target.value)>734000){
      this.setState({error:true})
    }
    else{
      this.setState({error:false})
    }
    this.props.onChange(name,e.target.value);
  }
  render(){
    return (
        <Input
          onChange = {this.onChange('plt')}
          fullWidth={true}
          placeholder="Range : 5300 - 734000"
          error={this.state.error}

        />
    );
  }
}


class ModelInput extends React.Component {
    onChange = name =>(e) =>{
      this.props.onChange(name,(e.target.value));
    }
    render(){
      return (
        <FormControl component="fieldset">
          <RadioGroup aria-label="gender" name="gender1" onChange={this.onChange("model")}>
            <FormControlLabel value="M4" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box fontWeight="fontWeightBold">Ordinal</Box>
                  <Box>(Calculates each class probability)</Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="M1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box fontWeight="fontWeightBold">Mild vs Above Moderate</Box>
                  <Box>
                    (Calculates probability of being Above Moderate)
                  </Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="M2" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box fontWeight="fontWeightBold">Below Moderate vs Above Severe</Box>
                  <Box>(Calculates probability of being Above Severe)</Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="M3" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box fontWeight="fontWeightBold">Below Severe vs Critical</Box>
                  <Box>(Calculates probability of being Above Severe)</Box>
                </Typography>
              </div>
            />
          </RadioGroup>

        </FormControl>

      );
    }
  }



class ModelInput2 extends React.Component {
  constructor(props){
    super(props);
    this.state={}
  }
  onChange = name => (e) => {
    this.props.onChange(name, (e.target.value));
  }
  onChange2 = name => (e) => {
    this.setState({binary:e.target.value});
    if(e.target.value=="false"){
      this.props.onChange("model", "M4");
    }
  }
  select = (binary)=> {

    if(binary=="true"){
      return(
        <div>
          <FormControl style={{minWidth: 200}}>
            <InputLabel labelId="demo-simple-select-label">Select Model</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            onChange={this.onChange("model")}
          >
            <MenuItem value={"M1"}>
              <Typography display="inline">
                <Box fontWeight="fontWeightBold">Mild vs Above Moderate</Box>
                <Box>(Calculates probability of being Above Moderate)</Box>
              </Typography>
            </MenuItem>
            <MenuItem value={"M2"}>
              <Typography display="inline">
                <Box fontWeight="fontWeightBold">Below Moderate vs Above Severe</Box>
                <Box>(Calculates probability of being Above Severe)</Box>
              </Typography>
            </MenuItem>
            <MenuItem value={"M3"}>
              <Typography display="inline">
                <Box fontWeight="fontWeightBold">Below Severe vs Critical</Box>
                <Box>(Calculates probability of being Critical)</Box>
              </Typography>
            </MenuItem>
          </Select>
        </FormControl>
        </div>

      )
  }
}
  render() {
    return (

      <FormControl component="fieldset">
        <Grid container
          direction="column"
          justify="flex-start"
          alignItems="flex-start"
          >
          <Grid item>
            <RadioGroup row onChange={this.onChange2("binary")}>
              <FormControlLabel value={"false"} control={<Radio />} label=<div>
                <Typography display="inline">
                  <Box >Multi-class model</Box>
                </Typography>
              </div>
              />
            <FormControlLabel value={"true"} control={<Radio />} label=<div>
                <Typography display="inline">
                  <Box >Binary-class model</Box>
                </Typography>
              </div>
              />
          </RadioGroup>
          </Grid>
          <Grid item>
            {this.select(this.state.binary)}
          </Grid>
        </Grid>

  </FormControl>);
  }
}
